import { UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { KeyLabel } from './key-label.model';
import { Marketplace } from './marketplace.model';
import { Source } from './moments.model';
import {Targeting} from './targeting.model';

export class Placements implements Podding, Exclusions {
  bidFloor: number;
  cpm: number;
  qpsLimit: number;
  shareOfVoice: number;
  createdBy: string;
  createdOn: Date;
  description: string;
  dpConnections: any;
  dpConnectionsCnt: number;
  gamBackfillAdUnit: string;
  gamEnabled: boolean;
  debug: boolean;
  multiImpEnabled: boolean;
  vwAdUnit: string;
  id: string;
  name: string;
  networkId: string;
  productType: ProductTypePlacement;
  deliveryType: DeliveryType;
  primaryAdServer: PrimaryAdServer;
  vastVersion: number;
  updatedBy: string;
  updatedOn: Date;
  status: PlacementStatus;
  secondaryId: string;
  poddingEnabled: boolean;
  ignoreCompliance: boolean;
  dvExclusionsEnabled: boolean;
  dpcMarketplaces: Marketplace[];
  // multi slot vast
  maxPodSlotCount: number;
  podFloor: number;
  minPodDuration: number;
  maxPodDuration: number;
  deduplicateUniqueMediaFile: boolean;
  deduplicateUniqueAdvertiserDomain: boolean;
  deduplicateUniqueIABCategory: boolean;
  exclusionsEnabled: boolean;
  advertiserDomains: string[];
  advertiserDomainsValue: string;
  iabCategoriesExcluded: string[];
  targetingCnt: number;
  targetingList: Array<Targeting>;
  cache: boolean;
  impressionTrackers: Array<string>;
  publishersIds: string[]; //pubId I guess
  notes: string;
  publishers: {
    id: string;
    name: string;
    network: {
      id: string;
      name: string;
      status: string;
    };
    secondaryId: string;
    status: string;
    allProductsCost: {
      value;
      costType;
    };
    apps?: Array<{
      id?: string;
      name?: string;
      bundleId?: string | null;
    }>;
  }[];
  stats: {
    global7daysRevenuePct: number;
    network7daysRevenuePct: number;
  };
  maxAdDuration: number;
  ssai: boolean;
  passToDemandAppData: boolean;
  passToDemandAppStoreIds: boolean;
  blockBidsWithoutCatOrAdomain: boolean;
  enableMoments: boolean;
  connectionType: string;
  ivtEnabled: boolean;
  ivtType: IvtType;
  ivtIntegrationType: IvtIntegrationType;

  stitcherEnabled: boolean;
  stAcceptPercentageOfFloor: number;
  stMaxBids: number;
  stMaxAvBids: number;
  stMaxVideoBids: number;
  stIgnoreAdDuration: boolean;
  stPoddingFloor: number;
  stFeeCpm: number;
  stDedupeEnabled: boolean;
  stDedupeUniqueMediaFile: boolean;
  stDedupeUniqueAdvertiserDomain: boolean;
  stDedupeUniqueIABCategory: boolean;

  cpmCapEnabled: boolean;
  cpmCapMin: number;
  cpmCapMax: number;
  cpmCapIncrement: number;

  upstreamCpmCapEnabled: boolean;
  upstreamCpmCapMinCpm: number;
  upstreamCpmCapMaxCpm: number;

  dmEnabled: boolean;
  dmShortTimeoutMs: number;
  dmLongTimeoutMs: number;
  momentSources: Source[];
  pricingType: PlacementPricingType;
  pricing: number;
  margin: number;
  adFormatId: string;
}

export interface Podding {
  poddingEnabled: boolean;
  // multi slot vast
  maxPodSlotCount: number;
  podFloor: number;
  minPodDuration: number;
  maxPodDuration: number;
  deduplicateUniqueMediaFile: boolean;
  deduplicateUniqueAdvertiserDomain: boolean;
  deduplicateUniqueIABCategory: boolean;
}

export class AdServerTypeMacros {
  adServerType: string;
  name: string;
  value: string;
  description: string;
}

export class PublisherCellData {
  id: string;
  name: string;
  network: {
    id: string;
    name: string;
    status: string;
  };
  status: string;
}

export interface Exclusions {
  exclusionsEnabled: boolean;
  /**
   * this is used for backed communication
   */
  advertiserDomains: string[];
  /**
   * This is used to bind with textarea
   */
  advertiserDomainsValue: string;

  iabCategoriesExcluded: string[];
}

export enum PlacementPricingType {
  REVSHARE = 'REVSHARE',
  CPM = 'CPM',
  NONE = 'NONE',
}

export interface ConnectionPlacement {
  name: string;
  status: string;
  bidFloor: number;
  productType: string;
}

export class PlacementStatusBox {
  count: number;
  status: string;
}

export class PlacementStatusListing {
  ACTIVE: number;
  INACTIVE: number;
  ARCHIVED: number;
}

export enum PlacementStatusColorMap {
  ACTIVE = 'green',
  INACTIVE = 'lightgray',
  ARCHIVED = 'gray',
}

export enum ProductTypePlacement {
  VIDEO = 'VIDEO',
  AUDIO_BACKFILL = 'AUDIO_BACKFILL',
  CONTENT_BYTE = 'CONTENT_BYTE',
  VIDEO_AUDIO_VIDEO = 'VIDEO_AUDIO_VIDEO',
  BACKFILL = 'BACKFILL',
  VAST_WEB = 'VAST_WEB',
}

export enum DeliveryType {
  APP = 'APP',
  CTV = 'CTV',
  WEB = 'WEB',
  DOOH = 'DOOH',
}

export enum DeliveryTypeLabels {
  APP = 'App',
  CTV = 'CTV',
  WEB = 'Web',
  DOOH = 'DOOH',
}

export enum PrimaryAdServer {
  SPRINGSERVE = 'SPRINGSERVE',
  PUBLICA = 'PUBLICA',
  FREEWHEEL = 'FREEWHEEL',
  O_AND_O = 'O_AND_O',
  VAST = 'VAST',
  RATE_BUYER = 'RATE_BUYER',
  PREBID_SERVER = 'PREBID_SERVER',
  UNSPECIFIED = 'UNSPECIFIED',
  OTHER = 'OTHER',
}

export enum PrimaryAdServerLabels {
  SPRINGSERVE = 'SpringServe',
  PUBLICA = 'Publica',
  FREEWHEEL = 'Freewheel',
  O_AND_O = 'O&O',
  VAST = 'VAST',
  RATE_BUYER = 'Rate Buyer',
  PREBID_SERVER = 'Prebid Server',
  UNSPECIFIED = 'Unspecified',
  OTHER = 'Other',
}

export enum IvtIntegrationType {
  PIXEL = 'PIXEL',
  WRAPPER = 'WRAPPER',
}

export enum IvtType {
  DOUBLE_VERIFY = 'DOUBLE_VERIFY',
  // MOAT = 'MOAT',
  HUMAN = 'HUMAN',
  IAS = 'IAS',
}

export enum IvtTypeLabels {
  DOUBLE_VERIFY = 'Double Verify',
  // MOAT = 'Moat',
  HUMAN = 'Human',
  IAS = 'IAS',
}

export const ProductTypePlacementLabels = {
  VIDEO: 'Video',
  AUDIO_BACKFILL: 'Audio to Video',
  CONTENT_BYTE: 'ContentByte',
  VIDEO_AUDIO_VIDEO: 'Video + Audio to Video',
  BACKFILL: 'Backfill',
  VAST_WEB: 'Vast Web',
};

export const ProductTypePlacementKL = () =>
  Object.keys(ProductTypePlacement).map(
    (key) =>
      new KeyLabel(<ProductTypePlacement>key, ProductTypePlacementLabels[key])
  );
export const DeliveryTypeKL = () =>
  Object.keys(DeliveryType).map(
    (key) =>
      new KeyLabel(<DeliveryType>key, DeliveryTypeLabels[key])
  );
export const PrimaryAdServerKL = () =>
  Object.keys(PrimaryAdServer).map(
    (key) =>
      new KeyLabel(<PrimaryAdServer>key, PrimaryAdServerLabels[key])
  );
export const IvtTypeKL = () =>
  Object.keys(IvtType).map(
    (key) =>
      new KeyLabel(<IvtType>key, IvtTypeLabels[key])
  );

export enum PlacementStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export const PlacementStatusLabels = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  ARCHIVED: 'Archived',
};

export const PlacementStatusKL = () =>
  Object.keys(PlacementStatus).map(
    (key) => new KeyLabel(<PlacementStatus>key, PlacementStatusLabels[key])
  );
  export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
      return !!(control && control.invalid && (control.dirty || control.touched));
    }
  }

